module.exports = __webpack_public_path__ + "be3b3e1cbeba5bea4f32b30b5f308b22.svg";